module.exports = __webpack_public_path__ + "img/btn-fukidashi.08f6368.png";